import { render, staticRenderFns } from "./interviewCandidateHeader.vue?vue&type=template&id=4c0755de&scoped=true"
import script from "./interviewCandidateHeader.vue?vue&type=script&lang=js"
export * from "./interviewCandidateHeader.vue?vue&type=script&lang=js"
import style0 from "./interviewCandidateHeader.vue?vue&type=style&index=0&id=4c0755de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0755de",
  null
  
)

export default component.exports